<template>
    <f7-page color-theme="teal" name="login" no-toolbar no-swipeback login-screen>
        <f7-navbar title="Todo Login"></f7-navbar>
        <f7-list form>
            <f7-list-item v-if="submitError!=''">
                <div class="errormsg">{{ submitError }}</div>
            </f7-list-item>
            <f7-list-item v-if="authFailed">
                <div class="errormsg">Incorrect login details</div>
            </f7-list-item>
            <f7-list-input
                    label="Email"
                    type="email"
                    placeholder="Your email"
                    :value="formdata.email"
                    @input="formdata.email = $event.target.value;inputChange();"
                    @blur="$v.formdata.email.$touch()"
                    required
                    validate
                    clear-button
            ></f7-list-input>
            <f7-list-input
                    label="Password"
                    type="password"
                    placeholder="Your password"
                    :value="formdata.password"
                    @input="formdata.password = $event.target.value"
                    @blur="$v.formdata.password.$touch()"
                    required
                    validate
                    clear-button
            ></f7-list-input>
            <!--<f7-list-item
                    checkbox
                    value="rememberme"
                    title="Remember me"
                    :checked="formdata.rememberme"
                    @change="changeRemember"
            ></f7-list-item>-->
            <f7-block>
                <f7-button raised big fill @click.prevent="onSubmit">Sign in</f7-button>
            </f7-block>
        </f7-list>
    </f7-page>
</template>

<script>
    import {required,email} from 'vuelidate/lib/validators';

    export default {
        data() {
            return {
                formdata:{
                    email:'',
                    password:'',
                    rememberme:false
                },
                submitError: ''
            };
        },
        watch: {
            isAuth(val) {
                if(val==true) {
                    this.$f7router.navigate('/todo');
                }
            }
        },
        computed: {
            authFailed() {
                return this.$store.state.admin.authFailed
            },
            isAuth() {
                return this.$store.getters['admin/isAuth']
            }
        },
        destroyed() {
            this.$store.commit('admin/authFailed','reset');
        },
        validations: {
            formdata: {
                email: {
                    required,
                    email
                },
                password: {
                    required
                }
            }
        },
        methods: {
            onSubmit() {
                this.submitError = '';
                if(!this.$v.$invalid) {
                    this.$store.commit('admin/authFailed','reset');
                    this.$store.dispatch('admin/signIn',this.formdata);
                }else{
                    this.submitError = 'Incorrect login details';
                }
            },
            changeRemember(event) {
                if(event.target.value == 'rememberme' && event.target.checked == true) {
                    this.formdata.rememberme = true;
                }else{
                    this.formdata.rememberme = false;
                }
            },
            inputChange() {
                this.submitError = '';
                this.$store.commit('admin/authFailed','reset');
            },
            checkAuth() {
                if(this.isAuth) {
                    this.$f7router.navigate('/todo');
                }
            }
        },
        mounted() {
            this.checkAuth();
        },

    };
</script>

<style>
    .errormsg {
        color: #721c24;
        background-color: #f8d7da;
        border-color: #f5c6cb;
        position: relative;
        padding: .75rem 1.25rem;
        margin-bottom: 1rem;
        border: 1px solid transparent;
        border-radius: .25rem;
        width:100%;
        font-size:13px;
    }
</style>